var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Пользователи","resource":"users","store":"users","columns":_vm.columns,"filter-options":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }